import { render, staticRenderFns } from "./RoleTab.vue?vue&type=template&id=6ba3ca25"
import script from "./RoleTab.vue?vue&type=script&lang=js"
export * from "./RoleTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports